import getAzureDomain from 'infrastructure/email/config/emailConfiguration';
import { STATUS_CHANGE_RULES } from '../constants';

const domainName = getAzureDomain();
const phoneNumberRegex = /^\+\d+$/;
const atLeastOneSpaceRegex = /^(?! ).* .*[^ ]$/;
const statusChangeCommentRequiredWhen = STATUS_CHANGE_RULES.map(({ currentFlag, initialFlag }) => ({
  [`$${String(currentFlag)}`]: {
    eq: true,
  },
  [`$${String(initialFlag)}`]: {
    eq: false,
  },
}));

export default {
  name: {
    type: 'object',
    required: true,
    _divisible: false,
    properties: {
      firstName: {
        type: 'string',
        maxSize: 255,
        required: false,
      },
      middleName: {
        type: 'string',
        maxSize: 255,
      },
      lastName: {
        type: 'string',
        maxSize: 255,
        required: false,
      },
      maidenName: {
        type: 'string',
        maxSize: 255,
      },
      fullName: {
        type: 'string',
        maxSize: 255,
        regex: {
          value: atLeastOneSpaceRegex,
          message: 'Full name must contain at least one space',
        },
      },
    },
  },

  dateOfBirth: {
    type: {
      value: 'date',
      message: 'Please, enter a valid date',
    },
    maxDate: {
      value: '$NOW',
      message: 'Must be in the past',
    },
  },
  status: {
    type: 'enum',
    required: {
      value: true,
      when: {
        $_IS_CREATE_REQUEST: {
          eq: false,
        },
      },
    },
  },
  statusChangeComment: {
    type: 'string',
    required: {
      value: true,
      when: statusChangeCommentRequiredWhen,
    },
    regex: {
      message: 'Comment cannot be empty',
    },
    minSize: 2,
    maxSize: 1024,
  },
  syberryEmail: {
    type: 'string',
    maxSize: 255,
    required: {
      value: false,
      when: {
        $isStudent: {
          eq: true,
        },
      },
    },
    regex: {
      value: `^.+@${domainName}$`,
      message: `Email must be within ${domainName} domain`,
    },
  },
  personalPhoneNumber: {
    type: 'string',
    regex: {
      value: phoneNumberRegex,
      message: 'Please enter phone number in international format (+xxxxxxxxxxxx), max. 15 characters',
    },
    maxSize: 15,
  },
  otherPhoneNumber: {
    type: 'string',
    regex: {
      value: phoneNumberRegex,
      message: 'Please enter phone number in international format (+xxxxxxxxxxxx), max. 15 characters',
    },
    maxSize: 15,
  },
  personalEmail: {
    type: 'string',
    email: true,
    maxSize: 255,
  },
  otherEmail: {
    type: 'string',
    email: true,
    maxSize: 255,
  },
  additionalContacts: {
    type: 'array',
    maxSize: 5,
    forEach: {
      type: 'object',
      _divisible: false,
      properties: {
        type: {
          required: false,
          maxSize: 255,
        },
        value: {
          required: false,
          maxSize: 255,
        },
      },
    },
  },
  resume: {
    type: 'object',
    properties: {
      resumeArtifactIds: {
        type: 'array',
        maxSize: 5,
      },
      description: {
        type: 'string',
        maxSize: 65000,
      },
    },
  },
};
